import {
  Flex,
  Text,
} from "@chakra-ui/react";
import { PrimaryButton } from "components/Button";
import { InternalLink } from "components/Link";
import { SHARED_ROUTES } from "definitions/constants/routeConstants";
import { PropsWithChildren } from "react";

const text1 = "In order to send quick messages via Slack from your account, you must give Camino permission.";
const text2 = "Camino will not send automated messages from your account, only messages you explicitly approve/send.";
const text4 = "To give Camino permission, click the button below and follow the instructions.";

export default function RedirectToSlackMessageOauthForm({
  children,
  ...rest
}: PropsWithChildren) {
  return (
    <Flex direction="column" gap="2" pb="2">
      <Text>
        {text1}
      </Text>
      <Text fontWeight="medium" fontStyle="italic">
        {text2}
      </Text>
      <Text mb="4">
        {text4}
      </Text>
      <InternalLink to={SHARED_ROUTES.individualSettings} target="_blank">
        <PrimaryButton>
          Authorize Camino
        </PrimaryButton>
      </InternalLink>
    </Flex>
  );
}
